import { render, staticRenderFns } from "./MessageContainerComponent.vue?vue&type=template&id=59da3ae3&scoped=true"
import script from "./MessageContainerComponent.vue?vue&type=script&lang=js"
export * from "./MessageContainerComponent.vue?vue&type=script&lang=js"
import style0 from "./MessageContainerComponent.vue?vue&type=style&index=0&id=59da3ae3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59da3ae3",
  null
  
)

export default component.exports